// Copy only editable business fields. Never spread an API entity into a new record:
// it can contain tenant IDs, permissions, financial settings or server metadata.
function pick(source, keys) {
  return Object.fromEntries(keys
    .filter((key) => source[key] !== undefined && source[key] !== null)
    .map((key) => [key, source[key]]));
}

function copyName(name) {
  return name ? `${name} (Kopie)` : "Kopie";
}

const addressAndContactFields = [
  "street", "postcode", "city", "countryCode", "contactName",
  "contactOrgUnit", "contactEmailAddress", "contactPhoneNo",
];

function copyArticle(source = {}) {
  return {
    ...pick(source, ["unitCode", "netUnitPrice", "taxPercent", "categoryCode"]),
    id: "",
    articleNumber: "",
    globalID: "",
    name: copyName(source.name),
  };
}

function copyCustomer(source = {}) {
  return {
    ...pick(source, addressAndContactFields),
    id: "",
    customerNumber: "",
    name: copyName(source.name),
    globalID: "",
    globalIDSchemeIdentifier: "0",
    electronicAddress: "",
    taxRegistrations: [],
  };
}

function copyCompany(source = {}) {
  return {
    ...pick(source, [...addressAndContactFields, "defaultTheme", "exportLocale"]),
    id: "",
    companyNumber: "",
    name: copyName(source.name),
    isDefault: false,
    logoFileId: null,
    globalID: "",
    globalIDSchemeIdentifier: "0",
    electronicAddress: "",
    taxRegistrations: [],
    iban: "",
    bic: "",
    bankName: "",
    apiQuotaEnabled: false,
    apiQuotaPlanCode: "Flex",
    originalApiQuotaPlanCode: "Flex",
    apiQuotaPlanDisplayName: "Flex",
    maxOverageAmountEurosPerMonth: null,
  };
}

function copyPaymentTerm(source = {}) {
  return {
    ...pick(source, ["daysUntilDue", "textTemplate"]),
    id: "",
    name: copyName(source.name),
    isDefault: false,
  };
}

module.exports = { copyArticle, copyCustomer, copyCompany, copyPaymentTerm };
